var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "#1790FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0561523 18.0581C0.0561523 16.7497 1.11675 15.6891 2.42507 15.6891H9.05802C10.3663 15.6891 11.4269 16.7497 11.4269 18.0581C11.4269 19.3664 10.3663 20.427 9.05802 20.427H2.42507C1.11675 20.427 0.0561523 19.3664 0.0561523 18.0581Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.322 17.9652C13.322 17.4129 13.7697 16.9652 14.322 16.9652H18.9929C19.5452 16.9652 19.9929 17.4129 19.9929 17.9652V18.1888C19.9929 18.7411 19.5452 19.1888 18.9929 19.1888H14.322C13.7697 19.1888 13.322 18.7411 13.322 18.1888V17.9652Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7693 14.7416C17.3216 14.7416 17.7693 15.1893 17.7693 15.7416L17.7693 20.4124C17.7693 20.9647 17.3216 21.4124 16.7693 21.4124L16.5457 21.4124C15.9934 21.4124 15.5457 20.9647 15.5457 20.4124L15.5457 15.7416C15.5457 15.1893 15.9934 14.7416 16.5457 14.7416L16.7693 14.7416Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0561523 10.4775C0.0561523 9.16921 1.11675 8.10861 2.42507 8.10861H17.5861C18.8944 8.10861 19.955 9.16921 19.955 10.4775C19.955 11.7858 18.8944 12.8464 17.5861 12.8464H2.42507C1.11675 12.8464 0.0561523 11.7858 0.0561523 10.4775Z",
    fill: "#444444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0561523 2.89699C0.0561523 1.58867 1.11675 0.528076 2.42507 0.528076H17.5861C18.8944 0.528076 19.955 1.58867 19.955 2.89699C19.955 4.20531 18.8944 5.2659 17.5861 5.2659H2.42507C1.11675 5.2659 0.0561523 4.20531 0.0561523 2.89699Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNum);
export default __webpack_public_path__ + "static/media/num.3530648b.svg";
export { ForwardRef as ReactComponent };